export class InstallationData {
    name: string;
    fname: string;
    street1: string;
    zip: string;
    city: string;
    state: string;
    phone: string;
    phone2: string;
    e_mail1: string;
    e_mail2: string;
    panel: string;
    alias: string;

    constructor() {
        this.name= "";
        this.fname= "";
        this.street1= "";
        this.zip= "";
        this.city= "";
        this.state= "";
        this.phone= "";
        this.phone2= "";
        this.e_mail1= "";
        this.e_mail2= "";
        this.panel = "";
        this.alias = "";
    }
}